import React, { useEffect, useRef } from 'react';
export type TabId = 'overview' | 'how-it-works' | 'audit-trust' | 'early-access';
interface TabNavigationProps {
  activeTab: TabId;
  onTabChange: (id: TabId) => void;
}
export function TabNavigation({
  activeTab,
  onTabChange
}: TabNavigationProps) {
  const tabs: {
    id: TabId;
    label: string;
  }[] = [{
    id: 'overview',
    label: 'Overview'
  }, {
    id: 'how-it-works',
    label: 'How It Works'
  }, {
    id: 'audit-trust',
    label: 'Audit & Trust'
  }, {
    id: 'early-access',
    label: 'Early Access'
  }];
  const scrollRef = useRef<HTMLDivElement>(null);
  // Scroll active tab into view on mobile
  useEffect(() => {
    if (scrollRef.current) {
      const activeElement = scrollRef.current.querySelector(`[data-state="active"]`);
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [activeTab]);
  return <div className="w-full border-b border-gray-200 bg-white" data-id="element-263">
      <div className="max-w-5xl mx-auto px-4" data-id="element-264">
        <div ref={scrollRef} className="flex space-x-8 overflow-x-auto scrollbar-hide -mb-px" role="tablist" aria-label="Main navigation" data-id="element-265">
          {tabs.map(tab => {
          const isActive = activeTab === tab.id;
          return <button key={tab.id} role="tab" aria-selected={isActive} aria-controls={`${tab.id}-panel`} id={`${tab.id}-tab`} data-state={isActive ? 'active' : 'inactive'} onClick={() => onTabChange(tab.id)} className={`
                  whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2
                  ${isActive ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                `} data-id="element-266">
                {tab.label}
              </button>;
        })}
        </div>
      </div>
    </div>;
}